// 定义所需的 mutations
const mutations = {
    putConnections(state,data){
        state.connections=data;
    }

}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/database/mutations.js